import React, { useEffect, useState } from 'react';
import { Container, Paper, Table, TableBody, TableCell, TableHead, TableRow, Button, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import api from '../api/axiosConfig';

const DepartamentoList = () => {
  const [departamentos, setDepartamentos] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/departamentos/').then(res => setDepartamentos(res.data));
  }, []);

  return (
    <Container>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h5">Departamentos</Typography>
        <Button variant="contained" onClick={() => navigate('/departamentos/nuevo')}>Nuevo Departamento</Button>
      </Box>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Código</TableCell>
              <TableCell>Descripción</TableCell>
              <TableCell>Sector</TableCell>
              <TableCell>Programa</TableCell>
              <TableCell>Proyecto</TableCell>
              <TableCell>Responsable</TableCell>
              <TableCell>Activo</TableCell>
              <TableCell>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {departamentos.map(dep => (
              <TableRow key={dep.id_departamento}>
                <TableCell>{dep.codigo}</TableCell>
                <TableCell>{dep.descripcion}</TableCell>
                <TableCell>{dep.sector?.descripcion}</TableCell>
                <TableCell>{dep.programa?.descripcion}</TableCell>
                <TableCell>{dep.proyecto?.descripcion}</TableCell>
                <TableCell>{dep.responsable}</TableCell>
                <TableCell>{dep.activo ? 'Sí' : 'No'}</TableCell>
                <TableCell>
                  <Button size="small" variant="outlined" onClick={() => navigate(`/departamentos/${dep.id_departamento}`)}>
                    Editar
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
};

export default DepartamentoList;